/*eslint-disable*/
// chakra imports
import { Box, useColorModeValue, Flex, Button, Text } from "@chakra-ui/react";
import React from "react";
import SidebarContent from "./SidebarContent";
import IconBox from "components/Icons/IconBox";
import { ProfileIcon } from "components/Icons/Icons";
import { LogoutIcon } from "components/Icons/Icons";
import { Separator } from "components/Separator/Separator";
import InfoPanel from "./InfoPanel";

// FUNCTIONS

function Sidebar(props) {
  // to check for active links and opened collapses
  const mainPanel = React.useRef();
  let variantChange = "0.2s linear";

  const { logoText, routes  } = props;

  //  BRAND
  //  Chakra Color Mode

  const sidebarBg = useColorModeValue("light.sidebar", "dark.sidebar");
  const sidebarRadius = "0px";
  const sidebarMargins = "0px";

  // SIDEBAR
  return (
    <Box ref={mainPanel}>
      <Box display={{ sm: "none", lg: "block" }} position="fixed">
        {/* <Box
          bg={sidebarBg}
          transition={variantChange}
          w="260px"
          maxW="260px"
          ms={{
            sm: "16px",
          }}
          my={{
            sm: "16px",
          }}
          minH="calc(100vh - 64px)"
          ps="20px"
          pe="20px"
          m={sidebarMargins}
          borderRadius={sidebarRadius}
        >
          <SidebarContent routes={routes}
        logoText={logoText}
        display="none"
        /> */}
        <Box
          className="sidebar-scroll"
          bg={sidebarBg}
          transition={variantChange}
          w="260px"
          maxW="260px"
          h="100vh"
          dir="rtl"
          overflow="hidden"
          display="flex"
          flexDirection="column"
        >
          <InfoPanel />
          <Separator ></Separator>
          <Separator></Separator>
          <SidebarContent routes={routes} logoText={logoText} />

          {/* <div
            style={{
              backgroundColor: "#35b3ac",
              width: "100%",
              padding: "10px 0",
              
            }}
          >
            <Button
              position="relative"
              zIndex="1"
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg="transparent"
              w="87%"
              py="10px"
              ps="16px"
              borderRadius="8px"
              mb="0"
              _hover={{
                bg: "#139693",
                shadow : "lg"
              }}
              mr={2}
            >
              <Flex>
                <IconBox
                  bg="white"
                  color="teal.300"
                  h="30px"
                  w="30px"
                  me="12px"
                >
                  <LogoutIcon /> 
                </IconBox>
                <Text color="white" my="auto" fontSize="sm">
                 خروج 
                </Text>
              </Flex>
            </Button>
          </div> */}
        </Box>
      </Box>
    </Box>
  );
}

export default Sidebar;
